var plugin_default = {
  "alignLeft": "H-CLz",
  "textWrapNowrap": "Oflfh",
  "alignRight": "Y244q",
  "alignCenter": "xnkDq",
  "sizeFullWidth": "LAZGj",
  "renderedInTable": "Lz-j5",
  "sizeOriginal": "Klg-t",
  "sizeContent": "OUmLL",
  "sizeSmall": "WlxpA",
  "sizeSmallCenter": "Mp3Qk",
  "flex": "us1yN",
  "atomic": "_2BjXl",
  "embed": "wKynL",
  "horizontalScrollbar": "gnuYB",
  "pluginContainerMobile": "bUEwm"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
